// extracted by mini-css-extract-plugin
export default {"Container":"CompetitionsDropdown_Container__6VrfL","Label":"CompetitionsDropdown_Label__gQ6hk"};